import type { AppModule } from '@/shared/types';
import * as routes from './routes';

export const AdminReadingPlansModule: AppModule = {
  routes,
};
